export default 
[
  {
    id: 1, 
    nome: 'RDIDP'
  },
  {
    id: 2, 
    nome: 'RTC'
  },
  {
    id: 3, 
    nome: 'RTP'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/regime-trabalho-usp.js